export const ANALYTICS_HEAP_IDS = {
  MLP_WEBAPP: 'mlp-webapp',
  HEADER: 'header',
  MODULE: 'module',
  NAVBAR: 'navbar-item',
  CARD: 'card',
  PARAGRAPH: 'paragraph',
  BREADCRUMBS: 'breadcrumbs-item',
  FOOTER_MARKETING: 'footer-marketing-item',
  FOOTER_GENERAL: 'footer-general-item',
  NAVBAR_EXPANSION: 'navbar-expansion-item',
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
};

export const formatHeapId = (labels: string[]) => {
  return `${ANALYTICS_HEAP_IDS.MLP_WEBAPP}-${labels.map((label) => label.toLowerCase().replace(/\s+/g, '-')).join('-')}`;
};
